module.exports = __webpack_public_path__ + "static/img/btn_05.f72c411.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/header/btn_05.png
// module id = /4rr
// module chunks = 4